import type { ComponentEntry } from '../../core/common-types'

const entry: ComponentEntry = {
	componentType: 'TPAMultiSection',
	loadComponent: () => import('../TpaCommon/TPABaseComponent.js' /* webpackChunkName: "TPABaseComponent" */),
}

export default entry
